import React from 'react';
import { Box, Tabs, Tab, Stack, TextField, Button, CircularProgress } from '@mui/material';
import { Chip } from '@mui/material';

export default function SearchControls(props) {
  const { searchMode, onModeChange, t, loadingModels, onSearch, searchAi } = props;

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={searchMode} onChange={onModeChange} aria-label="Search modes">
          <Tab label={t.classicSearchTitle} value="classic" />
          {searchAi && [
            <Tab key="chat" label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{t.chatAiTitle}<Chip label="NEW" color="error" size="small" sx={{ height: 22 }} /></Box>} value="chat" />,
          ]}
        </Tabs>
      </Box>

      <Box mt={3}>
        {searchMode === 'classic' && (
          <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} mb={2}>
            {/* Using Autocomplete from parent to keep imports simple in this small component */}
            {props.renderClassicInputs()}
            <Button onClick={onSearch} disabled={loadingModels} variant="contained" sx={{ height: 56, alignSelf: 'flex-end', minWidth: 120 }}>
              {loadingModels ? <CircularProgress size={24} /> : t.cerca}
            </Button>
          </Stack>
        )}
        {searchMode === 'chat' && (
          <Box mb={2} sx={{ fontSize: 14, color: 'text.secondary' }}>
            {/* {t.chatAiHelp || 'Conversazione guidata: descrivi il veicolo e cosa ti serve (codici, calibrazioni, istruzioni).'} */}
          </Box>
        )}
      </Box>
    </>
  );
}
